<template>
  <template v-if="time.zupGuid">
    <div
      class="time-slot-wrap"
      :class="{'time-slot': true, 'time-slot-big': time.big, 'time-slot-passed': time.passed}"
      v-if="isTimeSlotVisible"
    >
      <div class="time-slot-inner" :class="{'time-slot-big-inner': isBigLabel}">
        <span
          class="time-slot-label"
          :class="[label.classname, {'time-slot-label-split': timeSlotLabels.length > 1}]"
          v-for="(label, labelIndex) in timeSlotLabels"
          :key="labelIndex"
        >
          {{label.name}}
        </span>
        <div class="time-slot">
          {{time.timeFrom}} - {{time.timeTo}}
        </div>
      </div>
    </div>
  </template>
</template>
<script setup lang="ts">
import { TimeRange } from '@/types';
import { computed } from 'vue';

interface Props {
  time: TimeRange
  index: number
  shiftsLength: number
}

const props = defineProps<Props>()

// Составные типы смен, для которых выводится сразу несколько лейблов
const compositeTypes: Record<string, string[]> = {
  MainProfi: ['Main', 'ProfiPst']
}

// Получение стилей и названия согласно типу и статусу
const timeSlotType = (type: string, big: boolean) => {
  const typeObj: Record<string, { name: string; classname: string; big: boolean }> = {
    Main: {
      name: 'Осн.',
      classname: 'main-style',
      big: false
    },
    Exchange: {
      name: 'Беру!',
      classname: 'exchange-style',
      big: false
    },
    Partner: {
      name: 'Нап.',
      classname: 'partner-style',
      big: false
    },
    ProfiPst: {
      name: 'ПСТ',
      classname: 'profi-pst-style',
      big: false
    }
  }

  const current = typeObj[type]

  // Для всех остальных типов возвращаем базовый объект
  if (!current) {
    return {
      name: type || '',
      classname: '',
      big
    }
  }

  if (big) {
    if (type === 'Main') {
      current.name = 'Основная'
    }
    if (type === 'Partner') {
      current.name = 'Напарник'
    }
    current.big = true
  }

  return current
}

// У составных типов лейбл не растягиваем
const isBigLabel = computed(() => props.time.big && !compositeTypes[props.time.type])

// Лейблы смены: у составных типов их несколько
const timeSlotLabels = computed(() => {
  const types = compositeTypes[props.time.type] || [props.time.type]

  return types.map(type => timeSlotType(type, isBigLabel.value))
})

// Не выводим слоты со статусами Canceled и MissAccepted
const isTimeSlotVisible = computed(() => {
  return props.time.status !== 'Canceled' && props.time.status !== 'MissAccepted'
})
</script>